import {BehaviorSubject} from 'rxjs';
import {CONVERT_LANG_MAP} from '@/map';
import {writeLang} from '@/storage/lang';
import {mc} from '@/core';
import {userApi} from '@/api';
import {getCredential} from '@/modules/account/security/components/bind-passkeys/utils';
import {doCaptcha} from '@/captcha';
import lang from '@/modules/login/LoginPage.lang';

export const passKeyClickEvent$ = new BehaviorSubject<Record<string, boolean>>({event: false});
export const maskDialog$ = new BehaviorSubject<Record<string, boolean>>({visible: false});

export async function loginCheck(p) {
  const {email, onStatusReset} = p;
  const {data, error} = await userApi.loginCheckPasskey({emails: email});
  if (data) {
    const passkeys = Object.values(data).filter((r: Record<string, boolean>) => r.passkeyEnable);
    if (passkeys.length > 0) {
      // passkey 认证
      verifyPasskeyCredential(p);
      return;
    }
    onStatusReset({isLoading: false, isShowPasskeyDesc: false, isOpenPasskey: false});
  }
  if (error) {
    onStatusReset({isLoading: false, isShowPasskeyDesc: false, isOpenPasskey: false});
  }
}

async function verifyPasskeyCredential(p) {
  const {email, LG, onStatusReset, onShowDialog} = p;
  const captchaResult = await doCaptcha('login');
  if (!captchaResult) {
    mc.send('toast', 'error', {message: LG(lang.NetworkError)});
    onStatusReset({isLoading: false});
    return;
  }
  const {data, error} = await userApi.loginWithPasskey(captchaResult, {email}, LG);
  if (data) {
    if (data.assertionRequest?.publicKeyCredentialRequestOptions) {
      // passkey 认证
      confirmPasskeyLogin(p, data.flowId, data.assertionRequest);
      return;
    }
    onStatusReset({isLoading: false, isShowPasskeyDesc: false, isOpenPasskey: false});
  }
  if (error) {
    // verify error dialog
    onShowDialog?.();
  }
}

async function confirmPasskeyLogin(p, flowId, assertionRequest) {
  const {LG, onStatusReset, onShowDialog, pathName} = p;
  onStatusReset({isShowPasskeyDesc: true});
  try {
    maskDialog$.next({visible: true});
    const credential = await getCredential(assertionRequest);
    maskDialog$.next({visible: false});
    const {data, error} = await userApi.loginConfirmWithPasskey({flowId, credential: JSON.stringify(credential)});
    if (data) {
      // passkey confirm
      const language = data.lang;
      language && writeLang(CONVERT_LANG_MAP[language] || language);
      mc.send('toast', 'info', {message: LG(lang.LoggedIn)});
      setTimeout(() => {
        window.location.assign(pathName);
      }, 200);
    }
    if (error) {
      onStatusReset({isLoading: false, isShowPasskeyDesc: true});
      mc.send('toast', 'error', error);
    }
  } catch (e) {
    maskDialog$.next({visible: false});
    if (e.code === 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY') {
      onShowDialog?.();
      onStatusReset({isLoading: false, isShowPasskeyDesc: true});
      return;
    }
    onShowDialog?.();
    mc.send('toast', 'error', e);
  }
}

export function isEmpty(d) {
  return d === null || d === undefined;
}

export function checkTarget(target) {
  if (!target) {
    return false;
  }

  if (target.indexOf('@') > -1) {
    return false;
  }

  if (/^https?:/.test(target)) {
    const targetUrl = new URL(target);
    return targetUrl.host === location.host;
  }

  return true;
}
